import React from "react";
import Modal from '../components/Modal'
import { countriesList } from '../variables/countries'
import { getCountryCodeOfPhoneNumber, translate } from "../utils/useful";


class CountriesCodeList extends React.Component {
    state = {
        countries: []
    }

    componentDidMount() {
        this.setState({ countries: countriesList })

    }

    showModal = () => {
        this.setState({ countries: countriesList })
        this.countiesCodeModal.showModal()
        document.addEventListener("keydown", this._handleKeyDown);
    }

    hideModal = () => {
        this.countiesCodeModal.hideModal()
        document.removeEventListener("keydown", this._handleKeyDown);

    }

    _handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            this.hideModal()
        }
    }



    selectByCode = (code, lastAttempt) => {
        // console.log('this.props.datac3', code, lastAttempt)
        let codeWithoutZeros = code//String(this.removeCodeZeros(code))
        // console.log('this.props.datac4', codeWithoutZeros)
        let countriesList2 = JSON.parse(JSON.stringify(countriesList))
        // countriesList2.filter((e) => console.log('this.props.datac5', e.dial_code, codeWithoutZeros))
        let country = countriesList2.filter((e) => e.dial_code === (codeWithoutZeros ? codeWithoutZeros.replace('+', '') : null))[0]
        if (country) {
            country = { ...country }
            // country.dial_code = this.addCodeZeros(country.dial_code)
            // console.log('this.props.datac6', country)
            this.props.selectCountyCode(country)
        } else if (!lastAttempt) {
            this.selectByCode(code, true)
        }
    }


    selectByCountryCode = (code, lastAttempt) => {

        // console.log("CODE",code)
        let country = countriesList.filter((e) => e.code === code)[0]

        // console.log("country",country)

        if (country) {
            country = JSON.parse(JSON.stringify(country))

            this.props.selectCountyCode(country)
        } else if (!lastAttempt) {
            this.selectByCountryCode(code, true)
        }
    }


    selectCountyCode = (selectedCountry) => {
        // selectedCountry.dial_code = this.addCodeZeros(selectedCountry.dial_code)
        this.props.selectCountyCode(selectedCountry)
        this.hideModal()
    }


    removeCodeZeros(code) {
        let prefix = ''
        let stripCode = code
        // console.log(code)
        // if (code && String(code).includes('-')) {
        //     prefix = code.substring(0, 3)
        //     stripCode = code.substring(3, code.length)
        // }
        stripCode = String(Number(stripCode))
        // stripCode = prefix + stripCode
        return stripCode
    }

    addCodeZeros(code) {
        // let prefix = ''
        // let stripCode = code
        // if (code.includes('-')) {
        //     prefix = code.substring(0, 3)
        //     stripCode = code.substring(3, code.length)
        // }
        // let zeros = ''
        // for (let index = 0; index < 4 - stripCode.length; index++) {
        //     zeros = zeros + '0'
        // }
        // stripCode = prefix + zeros + stripCode
        // return stripCode
        return code
    }

    valueToCode(value) {
        // if (value && value !== "") {
        //     let newValue = getCountryCodeOfPhoneNumber(value)//value.includes('-') ? value.substring(3, value.length) : value
        //     newValue = String(Number(newValue))
        //     return newValue
        // } else {
        //     return ""
        // }
        return "+" + value
    }


    searchCountries(value) {
        let countries = []
        countries = countriesList.filter(e => e.name.toLowerCase().includes(value.toLowerCase()) || e.dial_code.toLowerCase().includes(value.toLowerCase()))
        this.setState({ countries })
    }


    render() {
        return (

            <Modal ref={el => this.countiesCodeModal = el} maxWidth={400}>
                <div className="pb-5 w-100 h-100">
                    <div className="w-100 h-100" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="w-100" style={{ zIndex: 1, padding: '14.2px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#ECF0F4,#ECF0F4)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

                            <p className="main-c2 font-size-16 weight-600">{translate('Select Country Code')}</p>

                            <button className="cursor-pointer flexcc" onClick={() => this.hideModal()} style={{}}>
                                <img style={{ width: 16, height: 16 }} src="/assets/icons/close.svg" alt="" />
                            </button>

                        </div>
                        <div className="w-100 px-3 py-2" style={{ backgroundColor: '#fff' }}>
                            <input onChange={(e) => this.searchCountries(e.target.value)} placeholder={translate("Search country ...")} className="w-100 br-6" style={{ height: 40, fontSize: 15, padding: '5px 15px', background: '#f2f4f6', border: '0px' }} />
                        </div>
                        <div className="px-2 pb-2" style={{ height: 'calc(100% - 106px' }}>
                            <div className="h-100 sc-3" style={{ overflow: 'auto' }}>

                                <div className="w-100 px-2 text-start" >
                                    {this.state.countries.map((prop, index) => {
                                        return (
                                            <div key={index} onClick={() => this.selectCountyCode(prop)} className="flexcb backHover pld-3 prd-4 pb-2 pt-2 cursor-pointer" style={{ borderBottom: '1px solid #f2f4f6' }}>
                                                <div className='flexcc mrd-3 py-1'>
                                                    {/* <img className="mld-1 mrd-1" src={prop.image} width="30px" alt={prop.name} /> */}
                                                    <p className="mrd-3" style={{ fontSize: 20, lineHeight: '14px' }} >{prop.flag}</p>

                                                    <span className="font-size-15 main-c2">{prop.name}</span>
                                                </div>

                                                <span className="font-size-14 main-c2">{this.valueToCode(prop.dial_code)}</span>
                                            </div>
                                        )
                                    })}

                                    {this.state.countries.length === 0 && (
                                        <p className="text-center mt-3 mb-3">{translate("Found nothing")}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );

    }
}


export default CountriesCodeList;
